<template>
  <view class="webview-container">
    <web-view :src="url" @message="handleMessage"></web-view>
  </view>
</template>

<script>
export default {
  data() {
    return {
      url: ''
    }
  },
  onLoad(options) {
    if (options.url) {
      this.url = decodeURIComponent(options.url)
    } else if (options.taskId) {
      // 这里的 URL 需要根据实际后端 H5 渲染页面的地址来配置
      // 假设地址是 config.apiBaseUrl + '/vform/render'
      const baseUrl = 'http://127.0.0.1:10076' // 建议从 config 引入
      const token = uni.getStorageSync('token')
      this.url = `${baseUrl}/vform/render?taskId=${options.taskId}&processInsId=${options.processInsId}&token=${token}`
    }
    console.log('WebView URL:', this.url)
  },
  methods: {
    handleMessage(evt) {
      console.log('Message from WebView:', evt.detail.data)
      // 处理来自 H5 的消息，例如表单提交成功后的回调
    }
  }
}
</script>

<style>
.webview-container {
  width: 100%;
  height: 100%;
}
</style>
